import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';


const CurriculumProgram = () => {
  const grades = [
    { grade: 'Lớp 1', color: 'bg-yellow-100 text-yellow-800' },
    { grade: 'Lớp 2', color: 'bg-yellow-100 text-yellow-800' },
    { grade: 'Lớp 3', color: 'bg-yellow-100 text-yellow-800' },
    { grade: 'Lớp 4', color: 'bg-yellow-100 text-yellow-800' },
    { grade: 'Lớp 5', color: 'bg-yellow-100 text-yellow-800' },
    { grade: 'Lớp 6', color: 'bg-green-100 text-green-800' },
    { grade: 'Lớp 7', color: 'bg-green-100 text-green-800' },
    { grade: 'Lớp 8', color: 'bg-green-100 text-green-800' },
    { grade: 'Lớp 9', color: 'bg-blue-100 text-blue-800' },
    { grade: 'Lớp 10', color: 'bg-blue-100 text-blue-800' },
    { grade: 'Lớp 11', color: 'bg-blue-100 text-blue-800' },
    { grade: 'Lớp 12', color: 'bg-blue-100 text-blue-800' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <div className="bg-white py-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Chương Trình Theo <span className="text-green-600">Bộ Giáo Dục</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            Marathon biên soạn bài giảng bám sát với chương trình của Bộ Giáo Dục,
            giúp học viên đạt thành tích học tập cao nhất.
          </p>
        </div>
      </div>

      {/* Grade Selection */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {grades.map((item, index) => (
            <div
              key={index}
              className={`${item.color} rounded-lg p-6 text-center cursor-pointer hover:shadow-lg transition-shadow`}
            >
              <h3 className="text-lg font-semibold">{item.grade}</h3>
            </div>
          ))}
        </div>

        {/* Features Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">📚</span>
            </div>
            <h3 className="text-xl font-semibold mb-4">Chương trình chuẩn</h3>
            <p className="text-gray-600">
              Bám sát chương trình Bộ Giáo Dục, đảm bảo kiến thức đầy đủ và chính xác
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">👨‍🏫</span>
            </div>
            <h3 className="text-xl font-semibold mb-4">Giáo viên chuyên nghiệp</h3>
            <p className="text-gray-600">
              Đội ngũ giáo viên giàu kinh nghiệm, am hiểu sâu sắc chương trình học
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl">🎯</span>
            </div>
            <h3 className="text-xl font-semibold mb-4">Phương pháp hiệu quả</h3>
            <p className="text-gray-600">
              Áp dụng phương pháp giảng dạy hiện đại, tương tác cao
            </p>
          </div>
        </div>

        {/* Subjects by Level */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-bold text-center mb-8">Môn học theo từng cấp</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <h3 className="text-xl font-semibold mb-4 text-yellow-600">Tiểu học (Lớp 1-5)</h3>
              <ul className="space-y-2 text-gray-600">
                <li>Toán học</li>
                <li>Tiếng Việt</li>
                <li>Tiếng Anh</li>
                <li>Tự nhiên & Xã hội</li>
                <li>Đạo đức</li>
              </ul>
            </div>

            <div className="text-center">
              <h3 className="text-xl font-semibold mb-4 text-green-600">Trung học cơ sở (Lớp 6-9)</h3>
              <ul className="space-y-2 text-gray-600">
                <li>Toán học</li>
                <li>Ngữ văn</li>
                <li>Tiếng Anh</li>
                <li>Vật lý</li>
                <li>Hóa học</li>
                <li>Sinh học</li>
                <li>Lịch sử</li>
                <li>Địa lý</li>
              </ul>
            </div>

            <div className="text-center">
              <h3 className="text-xl font-semibold mb-4 text-blue-600">Trung học phổ thông (Lớp 10-12)</h3>
              <ul className="space-y-2 text-gray-600">
                <li>Toán học</li>
                <li>Ngữ văn</li>
                <li>Tiếng Anh</li>
                <li>Vật lý</li>
                <li>Hóa học</li>
                <li>Sinh học</li>
                <li>Lịch sử</li>
                <li>Địa lý</li>
                <li>GDCD</li>
              </ul>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-12">
          <button className="bg-blue-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors">
            Đăng ký học ngay
          </button>
        </div>
      </div>

      <Footer />
      
    </div>
  );
};

export default CurriculumProgram;
